export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  padding: '12px 18px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};

export const segmentStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};
